import { mutatorAction } from 'satcheljs';
import { taskModules, instanceFactory } from '../store/taskModule';

export const registerInstance = mutatorAction('CREATE_NEW_TASK_MODULE_INSTANCE', (id: string) => {
    const instanceStore = instanceFactory(id);
    taskModules().instances.set(id, instanceStore);
});
